import { getTranslation } from '../../../../../../../../common/react/utils/translations';
import { STATS_LEADERS_COLUMNS_FOR_CATEGORY } from '../../config/columns';
import { POSITIONS } from '../../config/positions';

export const composeColumnData = category => [
    {
        Header: getTranslation( 'label.statsLeaders.rank' ),
        accessor: 'rank',
        disableSortBy: true
    },
    {
        Header: getTranslation( 'label.statsLeaders.player' ),
        accessor: 'player',
        disableSortBy: true
    },
    {
        Header: 'Position',
        accessor: 'position',
        filter: ( rows, columnIds, values ) => {
            const relevantPositions = POSITIONS
                .filter( pos => values.includes( pos.name ) )
                .flatMap( pos => pos.keys );

            return !values.length ?
                rows :
                rows.filter( row => {
                    return relevantPositions.some( pos =>
                        pos === row.values.player.position
                    );
                } );
        }
    },
    {
        Header: 'Team',
        accessor: 'team',
        filter: ( rows, columnIds, values ) => {
            return !values.length ?
                rows :
                rows.filter( row => {
                    return values.some( team =>
                        team === row.values.team
                    );
                } );
        }
    },
    ...STATS_LEADERS_COLUMNS_FOR_CATEGORY[ category ]
        .map( col => ( {
            Header: col.abbreviation,
            accessor: col.id,
            sortDescFirst: true
        } ) )
];